<template>
  <v-container fluid pa-0 ma-0 fill-height>
    <v-toolbar class="pa-0 ma-0 toolbar-padding"
               color="white" flat dense fixed app>
      <v-btn small flat icon @click="$router.go(-1)">
        <v-icon size="24px">$vuetify.icons.navArrowLeft</v-icon>
      </v-btn>
      <h3 class="display-2" style="margin-bottom: 2px">회원가입</h3>
    </v-toolbar>

    <v-form v-model="isValid" style="width: 100%; height: 100%;" ref="form">
      <v-layout column wrap fill-height class="ma-0">
        <v-card flat tile class="card-shadow pt-0 px-4 pb-4">
          <div class="pt-5 px-3 autocomplete-color">
            <v-text-field v-model="email"
                          :rules="emailRules"
                          required
                          label="Email"
                          placeholder="이메일"
                          type="email">
            </v-text-field>
            <v-text-field v-model="password"
                          :rules="rules.password"
                          required
                          label="Password"
                          placeholder="비밀번호"
                          @focus="showCounter = true"
                          @blur="showCounter = false"
                          :counter="showCounter"
                          :type="showPassword ? 'text' : 'password'"
                          :append-icon="showPassword ? '$vuetify.icons.visible' : '$vuetify.icons.invisible'"
                          @click:append="showPassword = !showPassword">
            </v-text-field>
            <v-text-field v-model="name"
                          :rules="rules.name"
                          required
                          label="Name"
                          placeholder="닉네임">
            </v-text-field>

            <v-dialog v-model="showCalendar"
                      ref="birthCalendar"
                      :return-value.sync="birth"
                      lazy
                      full-width
                      width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="birth"
                              append-icon="$vuetify.icons.calendar"
                              label="Birth"
                              readonly
                              v-on="on"
                              placeholder="생년월일">
                </v-text-field>
              </template>
              <v-date-picker v-model="birth"
                             locale="ko"
                             :max="birthMax"
                             :day-format="date => { return date.split('-')[2] }"
                             no-title
                             color="primary"
                             prev-icon="$vuetify.icons.arrowLeft"
                             next-icon="$vuetify.icons.arrowRight">
                <v-spacer></v-spacer>
                <v-btn flat @click="showCalendar = false">닫기</v-btn>
                <v-btn flat color="primary" :disabled="!birth" @click="$refs.birthCalendar.save(birth)">선택</v-btn>
              </v-date-picker>
            </v-dialog>
          </div>
        </v-card>

        <v-card flat tile class="px-4 mt-2" style="flex-grow: 1;">
          <div class="px-3 pt-4 pb-3">
            <v-checkbox on-icon="$vuetify.icons.confirm"
                        off-icon="$vuetify.icons.confirm"
                        color="white"
                        :ripple="false"
                        class="mt-0 big-checkbox"
                        v-model="allChecked">
              <template v-slot:label>
                <v-layout column>
                  <h3 class="display-2">약관에 전체 동의합니다.</h3>
                  <div class="body-2">
                    <span style="text-decoration: underline;" @click.stop="openDialog('termsOfService')">{{ termsOfService.title }}</span>,
                    <span style="text-decoration: underline;" @click.stop="openDialog('privacyPolicy')">{{ privacyPolicy.title }}</span> 등
                  </div>
                </v-layout>
              </template>
            </v-checkbox>

            <v-divider class="mt-3 mb-4"></v-divider>

            <v-checkbox on-icon="$vuetify.icons.confirm"
                        off-icon="$vuetify.icons.confirm"
                        color="primary"
                        class="mt-0"
                        required
                        :rules="rules.check[0]"
                        value="service"
                        :ripple="false"
                        v-model="checkedAgreement">
              <template v-slot:label>
                <span class="body-2 mr-1"
                      style="text-decoration: underline;"
                      @click.stop="openDialog('termsOfService')">
                  {{ termsOfService.title }}
                </span>
                <span class="small-font" style="color: #2e5a75;">[필수]</span>
              </template>
            </v-checkbox>
            <v-checkbox on-icon="$vuetify.icons.confirm"
                        off-icon="$vuetify.icons.confirm"
                        color="primary"
                        class="mt-0"
                        required
                        :rules="rules.check[1]"
                        value="privacy"
                        :ripple="false"
                        v-model="checkedAgreement">
              <template v-slot:label>
                <span class="body-2 mr-1"
                      style="text-decoration: underline;"
                      @click.stop="openDialog('privacyPolicy')">
                  {{ privacyPolicy.title }}
                </span>
                <span class="small-font" style="color: #2e5a75;">[필수]</span>
              </template>
            </v-checkbox>
            <v-checkbox on-icon="$vuetify.icons.confirm"
                        off-icon="$vuetify.icons.confirm"
                        color="primary"
                        class="mt-0"
                        value="email"
                        :ripple="false"
                        v-model="checkedAgreement">
              <template v-slot:label>
                <span class="body-2 mr-1">마케팅 사용 및 메일 수신 동의</span>
                <span class="small-font">[선택]</span>
              </template>
            </v-checkbox>
            <v-checkbox on-icon="$vuetify.icons.confirm"
                        off-icon="$vuetify.icons.confirm"
                        color="primary"
                        class="mt-0"
                        value="push"
                        :ripple="false"
                        v-model="checkedAgreement">
              <template v-slot:label>
                <span class="body-2 mr-1">푸시 알람 수신 동의</span>
                <span class="small-font">[선택]</span>
              </template>
            </v-checkbox>
          </div>

          <div class="mx-3">
            <v-btn :disabled="!isValid"
                   :loading="loading"
                   block depressed color="#4a4a4a"
                   class="button-style"
                   style="color: white !important;"
                   @click="submit">
              확인
            </v-btn>
          </div>

        </v-card>
      </v-layout>
    </v-form>

    <v-snackbar v-model="snackbar" bottom vertical :timeout="3000" auto-height>
      {{ snackbarMessage }}
      <v-btn color="primary" flat @click="snackbar = false">닫기</v-btn>
    </v-snackbar>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar flat fixed dense>
          <v-btn small icon @click="dialog = false">
            <v-icon small>$vuetify.icons.cancel</v-icon>
          </v-btn>
          <h3 class="display-2" style="margin-bottom: 2px">{{ dialogTitle }}</h3>
        </v-toolbar>

        <v-card-text class="text-xs-left pt-5 mt-3" v-html="dialogContent"></v-card-text>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
  import firebase from 'firebase/app';
  import 'firebase/auth';
  import { mapActions } from 'vuex';
  import terms from '@/assets/js/terms';

  export default {
    name: 'EmailSignUp',
    computed: {
      allChecked: {
        get () {
          return this.checkedAgreement.length === 4;
        },
        set (flag) {
          if (flag) this.checkedAgreement = [ 'service', 'privacy', 'email', 'push' ];
          else this.checkedAgreement = [];
        }
      },
      privacyPolicy () {
        return terms.privacyPolicy;
      },
      termsOfService () {
        return terms.termsOfService;
      },
      emailRules () {
        return [
          v => !!v || '이메일을 입력하세요.',
          v => /.+@.+/.test(v) || '유효하지 않은 메일 주소입니다.',
          v => !!v && !this.existEmail || '이미 가입되어 있는 이메일 주소입니다.',
        ];
      }
    },
    data () {
      return {
        isValid: false,
        showPassword: false,
        showCounter: false,
        showCalendar: false,
        birthMax: '2999-01-01',
        email: '',
        existEmail: false,
        password: '',
        name: '',
        birth: '',
        checkedAgreement: [ 'service', 'privacy', 'email', 'push' ],
        rules: {
          password: [
            v => !!v || '비밀번호를 입력하세요.',
            v => /^(?=.*[a-zA-Z])((?=.*\d)|(?=.*\W)).{8,16}$/i.test(v)
              || '비밀번호는 8~16글자 사이, 영문 대소문자와 하나 이상의 숫자(또는 기호)를 포함하여 작성해 주세요.'
          ],
          name: [
            v => !!v || '닉네임을 입력하세요.',
            v => /^[가-힣a-zA-Z]*$/.test(v) || '닉네임에는 한글 또는 영문자만 사용가능합니다.'
          ],
          check: [
            [v => v.includes('service') || '필수 동의사항입니다.'],
            [v => v.includes('privacy') || '필수 동의사항입니다.'],
          ]
        },
        loading: false,
        snackbarMessage: '',
        snackbar: false,
        dialog: false,
        dialogTitle: '',
        dialogContent: '',
      };
    },
    created () {
      const offset = new Date().getTimezoneOffset();
      this.birthMax = new Date(new Date().getTime() - (offset * 60000)).toISOString().split('T')[0];
    },
    watch: {
      email (email, oldEmail) {
        if (email !== oldEmail) this.existEmail = false;
      },
    },
    methods: {
      ...mapActions('user', [ 'signUser', 'checkUserEmail' ]),
      openDialog (string) {
        this.dialog = true;
        this.dialogTitle = this[string].title;
        this.dialogContent = this[string].content;
      },
      showSnackbar (message) {
        this.snackbarMessage = message;
        this.snackbar = true;
      },
      submit () {
        this.loading = true;
        let root = this;
        this.checkUserEmail(this.email).then(response => {
          if (response.data) {
            this.existEmail = true;
            this.$refs.form.validate();
            this.loading = false;
            return false;
          } else {
            firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then(userRecord => {
              userRecord.user.getIdToken().then(idToken => {
                // console.log(idToken);
                // DB에 유저정보 저장 (가입절차)
                let newUser = {
                  token: idToken,
                  email: this.email,
                  name: this.name,
                  birthday: (new Date(this.birth).getTime() / 1000),
                  social_type: 'email',
                  allow_push: this.checkedAgreement.includes('push'),
                  allow_mail: this.checkedAgreement.includes('email')
                };
                root.signUser(newUser).then(() => {
                  // 인증메일 전송
                  firebase.auth().currentUser.sendEmailVerification().then(() => {
                    root.$router.replace({ name: 'EmailConfirm' });
                  }).catch(err => {
                    console.error(err);
                    // TODO: snackbar
                    root.showSnackbar('인증메일 전송과정에서 오류가 발생했습니다. 잠시 후 다시 시도해보세요.');
                    root.loading = false;
                  });
                }).catch(err => {
                  console.error(err);
                  root.showSnackbar('오류가 발생했습니다. 잠시 후 다시 시도해보세요.');
                  root.loading = false;
                });
              }).catch(err => {
                console.error(err);
                root.showSnackbar('오류가 발생했습니다. 잠시 후 다시 시도해보세요.');
                root.loading = false;
              });
            }, error => {
              console.error(error);
              if (error.code.includes('already-in-use')) {
                root.showSnackbar('가입 오류입니다. 관리자에게 문의하세요. (info@glorang.com)');
                root.loading = false;
              } else {
                root.showSnackbar('오류가 발생했습니다. 잠시 후 다시 시도해보세요.');
                root.loading = false;
              }
            });
          }
        }).catch(err => {
          console.error(err);
          this.loading = false;
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/.toolbar-shadow .v-toolbar__content {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  /deep/.toolbar-padding .v-toolbar__content {
    padding: 0 10px 0 16px;
  }

  /deep/.card-shadow {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  .button-style {
    height: 56px;
    font-size: 14px;
    letter-spacing: -0.3px;
  }
  .button-shadow {
    border: 1px solid map_get($colors, border) !important;
    box-shadow: 0 2px 4px rgba(#cdcdcd, 0.5) !important;
  }

  /deep/.autocomplete-color {
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active  {
      -webkit-box-shadow: 0 0 0 30px white inset !important;
    }
    /* Change text in autofill text box */
    input:-webkit-autofill {
      /*-webkit-text-fill-color: yellow !important;*/
    }
  }

  /deep/.v-input--checkbox {
    .v-input__slot {
      margin-bottom: 0 !important;
    }
    .v-messages {
      min-height: 12px;
    }
    i {
      margin: auto;
      font-size: 16px;
    }
    input[aria-checked=false] ~ i {
      color: #cdcdcd !important;
    }
  }

  .small-font {
    font-size: 10px;
    color: map_get($colors, brownish-grey);
  }

  /deep/.big-checkbox {
    .v-input--selection-controls__input {
      width: 32px;
      height: 32px;
      border-radius: 2px;
      background-color: #cdcdcd;
    }

    &.v-input--is-label-active {
      .v-input--selection-controls__input {
        background-color: map_get($colors, primary);
      }
    }
    input[aria-checked=false] ~ i {
      color: white !important;
    }
  }

</style>
